/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { IconArrowLeft, IconPictureInPicture } from "@/components/icons/player.icons";

import { ROUTES } from "@/config/routes";
import { useGetContentDetailPage, useGetEpisodeInfo } from "@/hooks/api/content.hooks";

const TopSideOfPlayer = ({ videoRef }: { videoRef: React.RefObject<HTMLVideoElement> }) => {
  const { id, episodeId } = useParams() as { id: string; episodeId: string };
  const { data } = useGetContentDetailPage(+id);
  const { data: episodeInfo } = useGetEpisodeInfo(+episodeId, data.content.is_serial);
  const { t } = useTranslation();

  const handlePictureInPicture = async () => {
    try {
      if (videoRef.current) {
        if (document.pictureInPictureElement) {
          await document.exitPictureInPicture();
        } else {
          await videoRef.current.requestPictureInPicture();
        }
      }
    } catch (error) {
      console.error("Error enabling Picture-in-Picture:", error);
    }
  };

  const location = useLocation();

  useEffect(() => {
    if (document.pictureInPictureElement) {
      handlePictureInPicture();
    }
  }, [location]);

  const navigate = useNavigate();

  const quitFromPlayer = () => {
    navigate(ROUTES.DETAIL.MAIN.replace(":id", String(id)));
    if (document.pictureInPictureElement) {
      handlePictureInPicture();
    }
  };

  return (
    <div className="relative flex items-center justify-between">
      <div className="flex items-center gap-6 max-lg:gap-2">
        <IconArrowLeft className="w-[50px] cursor-pointer stroke-white max-lg:w-[32px]" onClick={quitFromPlayer} />
        <div className="text-[22px] max-lg:absolute max-lg:top-[56px] max-lg:w-full max-lg:text-center max-lg:text-[18px]">
          <p>{data.content.title}</p>
          {data.content.is_serial && (
            <p className="text-dark-3 ">
              {t("player.season")}:{episodeInfo?.season_numb} {t("player.episode")}:{episodeInfo?.episode_numb}{" "}
            </p>
          )}
        </div>
      </div>
      <div className="flex gap-6 max-lg:gap-2">
        <div onClick={handlePictureInPicture}>
          <IconPictureInPicture className="player-icon !fill-transparent stroke-white" />
        </div>
        {/* <ProblemModal /> */}
      </div>
    </div>
  );
};

export default TopSideOfPlayer;
